<template>
  <div class="listmain ">
      <h1 class="firTitle">语音伴侣SDK（iOS）</h1>
      <h3 class="sedTitle">OrionServiceSDK 环境
      </h3>
      <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">
       &nbsp;&nbsp;&nbsp;&nbsp;OrionServiceSDK 最低支持iOS 8.0，framework 都是动态库。
          </span>
      </p>
      <h3 class="sedTitle">OrionServiceSDK 组件介绍
      </h3>
      <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">
        &nbsp;&nbsp;&nbsp;&nbsp;1.OrionServiceSDK 业务中心；<br>
 &nbsp;&nbsp;&nbsp;&nbsp;2.OVSComponetCenter 组件中心；<br>
 &nbsp;&nbsp;&nbsp;&nbsp;3.OVSChat 信息流组件；<br>
 &nbsp;&nbsp;&nbsp;&nbsp;4.OVSSkillStore 技能商店组件；<br>
 &nbsp;&nbsp;&nbsp;&nbsp;5.OVSMediaCodec 媒体解码库；
          </span>
      </p>

      <p class="ql-long-7802039">
          <span class="ql-author-7802039 ql-size-9">
 <b> 注意： </b><br>
 &nbsp;&nbsp;&nbsp;&nbsp;所有组件都依赖 OrionServiceSDK 业务中心、OVSComponetCenter 组件中心。
          </span>
      </p>
  </div>
</template>

<script>
export default {
  name: ""
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
h1,
h2,
h3,
h4,
h5 {
  padding: 0;
  margin: 0px;
  font-weight: normal;
}

ul,
li {
  list-style: none;
}

.listmain {
  font-size: 14px;
  line-height: 26px;
  .firTitle {
    font-size: 20px;
    color: #1e4d79;
    margin-bottom: 30px;
  }
  .sedTitle {
    font-size: 16px;
    font-weight: bold;
    padding-bottom: 10px;
    border-bottom: 1px solid #f3f3f3;
    margin-bottom: 15px;
    margin-top: 50px;
    &.fir {
      margin-top: 0px;
    }
  }
  .thirdTitle {
    margin-top: 50px;
    font-weight: bold;
    line-height: 30px;
    font-size: 16px;
  }
  .codeTitle {
    font-weight: bold;
    line-height: 26px;
  }
  pre {
    margin-top: 20px;
  }
  img {
    margin: 30px 0;
    width: 100%;
  }
  table,
  table tr th,
  table tr td {
    border: 1px solid #000;
    text-align: center;
  }
  table {
    line-height: 30px;
    width: 100%;
    border-collapse: collapse;
  }
}

.el-submenu .el-menu-item {
  min-width: 190px;
  background: #f5f5f5;
}

.el-submenu {
  min-width: 190px;
  background: #f5f5f5;
}

img {
  margin-top: 30px;
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/tutor/SDK-ios/access/Env.vue